export default __webpack_public_path__ + "static/media/admin_profile.b8e34671.png";